import React from 'react';
import './ABSTimeDot.less';
import moment from 'moment';
import ABSSubTitle from '../ABSSubTitle';

export interface IABSTimeDotProps {
  content: any;
}
 
export interface IABSTimeDotState {
  
}
 
class ABSTimeDot extends React.Component<IABSTimeDotProps, IABSTimeDotState> {
  render() {
    const { content } = this.props;
    return (
      <div className="abs-time-dot">
        <div className="abs-dot-date" >
          <ABSSubTitle title={moment(content).format('MM-DD')} className="abs-dot-date-title" />
          <div className="abs-dot-date-subtitle">{moment(content).format('YYYY')}</div>
        </div>
        <div className="abs-time-inner-dot" />
      </div>
    );
  }
}
 
export default ABSTimeDot;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSTimeline/ABSTimeDot.tsx